import { Div, P } from '@kizi/core-components';
import React from 'react';

const containerStyles = {
  display: 'flex',
  padding: '4px 8px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '16px',
  background: '#FFBB0E',
  minWidth: 65,
};

const textStyles = {
  fontSize: 12,
  color: '#855F00 !important',
};

export const OurAdvice = () => (
  <Div css={containerStyles}>
    <P variant="captionImportant" css={textStyles}>
      Ons advies
    </P>
  </Div>
);
